<script setup lang="ts">
import type { IDiscussionCategory } from '~/components/widget/discussions'

interface IProps {
  categories: IDiscussionCategory[]
}

const props = defineProps<IProps>()

const discussions = computed(() => {
  return (
    props.categories.map((i) => {
      return {
        id: i.id,
        title: i.title,
        url: i.url,
        icon: i.slug
      }
    }) || []
  )
})
</script>

<template>
  <SidebarBlock
    v-if="discussions.length"
    :heading-text="$t('widget.discussions.select_category.heading')"
    variant="white"
  >
    <SidebarMenu :menu-items="discussions" />
  </SidebarBlock>
</template>
